import React from "react";

const Ninth_Answer = () => {
  return (
    <>
      <div className="ninth_answer">
        <p>
          No, there are no charges or fees to be paid for the nomination by any
          Organization and /or individual. Grab this opportunity to nominate
          your institution for the most prestigious Awards and showcase to the
          world what makes your brand the best! However, the final winners
          opting to attend the award function need to select a promotional
          package depending on their requirements in terms of copyrights, media
          publicity, etc For opportunities as a sponsor, associate partner or
          presenter you can get in touch with us: +91-98210 20995‬, +91-98
          73004416.
        </p>
      </div>
    </>
  );
};

export default Ninth_Answer;
